import React from "react";
import volcano from "./logovolcano.png";
import av1 from "./av1.jpg";
import av2 from "./av2.jpg";
import av3 from "./av3.jpg";
import av5 from "./av5.jpg";
import "./temoignages.css";
import Aos from "aos";
import "aos/dist/aos.css";
function Temoignages() {
  React.useEffect(() => {
    Aos.init();
  }, []);

  return (
    <section id="temoignages">
      <div className="temoignage-head">
        <span> Commentaires </span>
        <h1> Temoignages ⭐ </h1>
      </div>

      <div
        class="temoignage-box-container"
        data-aos="zoom-in"
        data-aos-duration="1500"
      >
        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av1} />
              </div>
              <div class="name">
                <strong> Christian KPEDZROKU</strong>
                <span>@Christian </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="far fa-star"></i>
            </div>
          </div>
          <div className="comments">
            Très bon service, des menus assez variés, à des prix abordables. Je
            vous le conseille
          </div>
        </div>
        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av2} />
              </div>
              <div class="name">
                <strong> Cécile Gnt </strong>
                <span>@CG </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div className="comments">Acceuil chaleureux ,beaucoup de choix à pris abordable ,Repas copieurx,à recommander </div>
        </div>

        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av3} />
              </div>
              <div class="name">
                <strong> LEPASTEUR ANTOINE </strong>
                <span>@LA </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div className="comments">
            Rapide, pas cher et avec beaucoup de choix ! N hésitez pas à y aller
            !
          </div>
        </div>
        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av5} />
              </div>
              <div class="name">
                <strong>Hichem72 </strong>
                <span>@H72 </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div className="comments">Les chefs très chaleureux ,très sympa,acceuillons, pizza original top de top</div>
        </div>
        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av1} />
              </div>
              <div class="name">
                <strong> Mattéo Gonthier </strong>
                <span>@MG </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="far fa-star"></i>
            </div>
          </div>
          <div className="comments">
            Super kebab, le meilleur que j'ai gouté jusqu'à maintenant , Proprio
            super sympa et acceuillant
          </div>
        </div>
        <div class="temoignage-box">
          <div class="box-top">
            <div class="profile">
              <div class="profile-img">
                <img src={av2} />
              </div>
              <div class="name">
                <strong> Zakaria Loukili </strong>
                <span>@Zack01 </span>
              </div>
            </div>
            <div class="reviews">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div className="comments">
            les pizzas sont trop bonne surout celle à base sauce tomate mais
            aussi les pizza à base créme fraiche sont bonnes
          </div>
        </div>
      </div>
    </section>
  );
}

export default Temoignages;
